export const nameserver = "https://apituantrathietbi.ximangbimson.com.vn"
//export const nameserver = "http://localhost:5000"
// export const nameserver = "http://192.168.153.47:5000"

// http://192.168.153.47:3000
 